import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OptOutStep } from '@/types/common';
interface InitState {
  hasError: boolean;
  step: OptOutStep;
}
const initialState: InitState = {
  hasError: true,
  step: 'init',
};

export const optOutSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setError: (state, { payload }: PayloadAction<boolean>) => {
      state.hasError = payload;
    },
    setStep: (state, { payload }: PayloadAction<OptOutStep>) => {
      state.step = payload;
    },
  },
});
